import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgFacebookLogo = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#src__com__yext__listingslaunchstorm__public__icons__facebook-logo_svg__a)">
        <path
          d="M12 20.573A8.571 8.571 0 1 0 12 3.43a8.571 8.571 0 0 0 0 17.143Z"
          fill="#1977F3"
        />
        <path
          d="m15.337 14.48.38-2.479H13.34v-1.608c0-.677.331-1.339 1.397-1.339h1.08v-2.11s-.98-.167-1.918-.167c-1.958 0-3.238 1.186-3.238 3.335v1.89H8.484v2.477h2.177v5.99a8.605 8.605 0 0 0 2.679 0v-5.99h1.997Z"
          fill="#fff"
        />
      </g>
      <defs>
        <clipPath id="src__com__yext__listingslaunchstorm__public__icons__facebook-logo_svg__a">
          <path
            fill="#fff"
            transform="translate(3.429 3.429)"
            d="M0 0h17.143v17.143H0z"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export default SvgFacebookLogo;
